function Numbers() {
    function startCounters() {
        $(".numbers-item-counter div").each(function () {
            var $this = $(this);

            if ($this.hasClass("counted")) return;
            $this.addClass("counted");

            var target = parseInt($this.data("counter"), 10);
            if (isNaN(target)) return;

            $({ countNum: 0 }).animate(
                { countNum: target },
                {
                    duration: 2000,
                    easing: "swing",
                    step: function () {
                        $this.text(
                            Math.floor(this.countNum).toLocaleString("tr-TR"),
                        );
                    },
                    complete: function () {
                        $this.text(target.toLocaleString("tr-TR"));
                    },
                },
            );
        });
    }

    var section = document.querySelector(".numbers");
    if (!section) return;

    if (!("IntersectionObserver" in window)) {
        startCounters();
        return;
    }

    var observer = new IntersectionObserver(
        function (entries) {
            if (entries[0].isIntersecting) {
                startCounters();
                observer.disconnect();
            }
        },
        {
            threshold: 0.25,
        },
    );

    observer.observe(section);
}

Numbers();
